import isCampaignName from 'app/forms/validations/isCampaignName';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const CAMPAIGNS_LIST_FORM_NAME = 'campaignsList-filter';

const { channel, campaignName } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	campaignName,
	campaignState: 'campaignState',
	channel,
};

export default () => ({
	[FIELDS.campaignName]: {
		deepPath: [FIELDS.campaignName],
		validations: [isCampaignName()],
	},
	[FIELDS.campaignState]: {
		deepPath: [FIELDS.campaignState],
		validations: [],
	},
	[FIELDS.channel]: {
		deepPath: [FIELDS.channel],
		validations: [],
	},
});
